import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout.jsx';
import ScrollToTop from './components/layout/ScrollToTop.jsx';
import MetaPixelRouteTracker from './components/layout/MetaPixelRouteTracker.jsx';
import Home from './pages/Home.jsx';
import Demo from './pages/Demo.jsx';
import Contact from './pages/Contact.jsx';
import About from './pages/About.jsx';
import NotFound from './pages/NotFound.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MetaPixelRouteTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          {/* Pricing moved onto the home page. Kept as a redirect so existing
              links, bookmarks and indexed results land on the section rather
              than a 404. */}
          <Route path="/pricing" element={<Navigate to="/#pricing" replace />} />
          <Route path="/demo" element={<Demo />} />
          {/* The contact page and the demo page asked for the same thing with
              two different forms. Contact now resolves to the demo form, which
              is the better of the two, and old links still work. */}
          <Route path="/contact" element={<Navigate to="/demo" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
